<div class="errorMessage" *ngIf="message != null && message.length >0 ">
  <h2 id="errorMessage" class="u-color-red">{{message}}</h2>
</div>


<div class="extrnalErrorMessage" *ngIf="externalErrorMessage!= null && externalErrorMessage.length >0">
  <h2 class="pageHeader">eBoutique Online - Logon</h2>
  <label class="error-header">You must correct the following error(s) before proceeding:</label>
  <li id="extrnalErrorMessage" class="u-color-red">{{externalErrorMessage}}</li>
</div>
